import type { BugDetails, Task } from '../model/schema'

// Изменение полей задачи (camelCase). value = установить, null = снять (clear_*),
// отсутствие ключа = не трогать. Транслируется в PATCH-тело с тройной семантикой
// и одновременно годится как оптимистичный Partial<Task> (типы полей совпадают).
export interface TaskChange {
  title?: string
  description?: string
  dueDate?: string | null
  dueTime?: string | null
  priority?: number | null
  complexity?: number | null
  estimateHours?: number | null
  actualComplexity?: number | null
  bugDetails?: BugDetails | null
}

export interface TaskPatchBody {
  title?: string
  description?: string
  due_date?: string
  clear_due_date?: boolean
  due_time?: string
  clear_due_time?: boolean
  priority?: number
  clear_priority?: boolean
  complexity?: number
  clear_complexity?: boolean
  estimate_hours?: number
  clear_estimate_hours?: boolean
  actual_complexity?: number
  clear_actual_complexity?: boolean
  bug_details?: { steps_to_reproduce: string }
  clear_bug_details?: boolean
}

export function buildPatchBody(change: TaskChange): TaskPatchBody {
  const body: TaskPatchBody = {}
  if (change.title !== undefined) body.title = change.title
  if (change.description !== undefined) body.description = change.description

  if (change.dueDate !== undefined) {
    if (change.dueDate === null) body.clear_due_date = true
    else body.due_date = change.dueDate
  }
  if (change.dueTime !== undefined) {
    if (change.dueTime === null) body.clear_due_time = true
    else body.due_time = change.dueTime
  }
  if (change.priority !== undefined) {
    if (change.priority === null) body.clear_priority = true
    else body.priority = change.priority
  }
  if (change.complexity !== undefined) {
    if (change.complexity === null) body.clear_complexity = true
    else body.complexity = change.complexity
  }
  if (change.estimateHours !== undefined) {
    if (change.estimateHours === null) body.clear_estimate_hours = true
    else body.estimate_hours = change.estimateHours
  }
  if (change.actualComplexity !== undefined) {
    if (change.actualComplexity === null) body.clear_actual_complexity = true
    else body.actual_complexity = change.actualComplexity
  }
  if (change.bugDetails !== undefined) {
    if (change.bugDetails === null) body.clear_bug_details = true
    else body.bug_details = { steps_to_reproduce: change.bugDetails.stepsToReproduce }
  }
  return body
}

// Проекция изменения в кэш. Времени без даты не существует: снимая дату, бэк
// уносит и время — оптимистичный кэш обязан повторить это, иначе карточка
// покажет «17:00» у задачи без срока.
export function optimisticTaskPatch(change: TaskChange): Partial<Task> {
  return change.dueDate === null ? { ...change, dueTime: null } : change
}
